module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "btn-group pull-right",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCreateNew
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Create new\n      ")]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Dashboards")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync-dashboard"
    }
  }, [_vm._v("Dashboards")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.name) ? _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v(_vm._s(_vm.$route.params.name))]) : _vm._e()]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), (!_vm.$route.params.name) ? _c('vue-good-table', {
    attrs: {
      "title": "Sync Dashboards",
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'name',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: false
      },
      "search-options": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "paginationOptions": {
        enabled: true
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('span', [_vm._v("\n            " + _vm._s(props.row.name) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'actions') ? _c('span', [_c('div', {
          staticClass: "btn-group text-right",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.viewBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" View\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.updateBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-wrench",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Update\n            ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBtnClick(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Delete\n            ")])])]) : _vm._e()]
      }
    }], null, false, 1341246514)
  }) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Dashboard Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalDashboardNameInput),
      expression: "modalDashboardNameInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.modalIsEditMode
    },
    domProps: {
      "value": (_vm.modalDashboardNameInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalDashboardNameInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("The name of this dashboard.")])]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns2,
      "rows": _vm.rows2,
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "paginationOptions": {
        enabled: true,
        perPage: 5
      },
      "searchOptions": {
        enabled: false
      }
    },
    on: {
      "on-select-all": _vm.onSelectAll,
      "on-row-click": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'appName') ? _c('span', [_vm._v("\n              " + _vm._s(props.row.appName) + "\n            ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n              " + _vm._s(props.row.id) + "\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalBtnClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), (!_vm.$route.params.name) ? _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.repickAppsModalBtnClick
    }
  }, [_vm._v("Repick Apps")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveModalBtnClick
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalDeleteShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalDeleteShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._v("\n        Are you sure you want to delete this dashboard ?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-4 col-form-label text-danger"
  }, [_vm._v("Enter DELETE in capital letters")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalDeleteConfirmInput),
      expression: "modalDeleteConfirmInput"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalDeleteConfirmInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalDeleteConfirmInput = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalBtnClick
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.deleteDisabled
    },
    on: {
      "click": _vm.confirmDeleteModalBtnClick
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), (_vm.$route.params.name) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns3,
      "rows": _vm.rows2,
      "lineNumbers": true,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'appName',
          type: 'asc'
        }
      },
      "select-options": {
        enabled: false
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "paginationOptions": {
        enabled: false
      },
      "searchOptions": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'status') ? _c('span', [(props.row.status === 'Enabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-success"
        }, [_c('i', {
          staticClass: "fa fa-play",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Disabled') ? _c('div', [_c('span', {
          staticClass: "badge badge-warning"
        }, [_c('i', {
          staticClass: "fa fa-stop",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e(), _vm._v(" "), (props.row.status === 'Halted') ? _c('div', [_c('span', {
          staticClass: "badge badge-danger"
        }, [_c('i', {
          staticClass: "fa fa-exclamation-triangle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("\n              " + _vm._s(props.row.status) + "\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.column.field == 'appName') ? _c('span', [_vm._v("\n            " + _vm._s(props.row.appName) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'id') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.id) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumBaseUrl') ? _c('span', [_vm._v("\n        " + _vm._s(props.row.heliumBaseUrl) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyBaseUrl') ? _c('span', [_vm._v("\n          " + _vm._s(props.row.journeyBaseUrl) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'heliumLastUpdated') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.heliumLastUpdated)) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'journeyLastUpdated') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.journeyLastUpdated)) + "\n        ")]) : _vm._e(), _vm._v(" "), (props.column.field == 'lastPinged') ? _c('span', [_vm._v("\n          " + _vm._s(_vm.formatMillis(props.row.lastPinged)) + "\n        ")]) : _vm._e()]
      }
    }], null, false, 3823709548)
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/sync"
    }
  }, [_vm._v("Sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-info text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("View dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-info-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Update dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-wrench card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_c('p', [_vm._v("Remove dashboard")])]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-minus-circle card-block-watermark",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0433b1c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SyncDashboard.vue
// module id = 597
// module chunks = 2